import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { LeafCollectionSummaryReport } from './Pages';

export const LeafCollectionSummaryReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={LeafCollectionSummaryReport} />
    </Fragment>
)